import App from "../app";
import { ListItem } from "../model/datasource/list";
import { ContentItem } from "../model/datasource/item";
import { AttemptId, ProductId, ItemId, QuizId } from "../model/datasource";
import Model from "../model/model";

export default class Content<P extends ProductId, A extends AttemptId, Z extends QuizId, I extends ItemId> {
	app: App<P, A, Z, I>;
	product: P;
	list: ListItem<I>[];
	items: Record<string, ContentItem<I>>;
	queued: Record<number, Promise<ContentItem<I>>>;

	constructor() {
		this.list = [];
		this.items = {};
		this.queued = {};
	}

	init(items: ListItem<I>[], product: P, app: App<P, A, Z, I>): void {
		this.product = product;
		this.list = items;
		this.app = app;
	}

	fetch(index: number): Promise<ContentItem<I>> {
		this.queued[index] = Model.retryPromise<ContentItem<I>>(() => this.app.model.item
			.getItem(this.product, this.list[index].id, this.app.config.randomizeAnswers)
		)
			.then(content => {
				content.name = this.list[index].name;
				this.items[index] = content;
				return content;
			});
		return this.queued[index];
	}

	get(index: number): Promise<ContentItem<I>> {
		if (index in this.items) {
			return Promise.resolve(this.items[index]);
		} else if (index in this.queued) {
			return this.queued[index];
		} else {
			return this.fetch(index);
		}
	}

	meta(index: number): Promise<ListItem<I>> {
		if (index in this.list) {
			return Promise.resolve(this.list[index]);
		} else {
			return Promise.reject();
		}
	}

	remove(index: number): Promise<ContentItem<I>> {
		let item: Promise<ContentItem<I>> = (
			index in this.queued
				? this.queued[index]
				: index in this.items
					? Promise.resolve(this.items[index])
					: Promise.resolve(undefined)
		);
		if (index in this.queued) { delete this.queued[index]; }
		if (index in this.items) { delete this.items[index]; }
		return item;
	}

	count(): number {
		return this.list.length;
	}
}
